import React from 'react'
import { connect } from 'react-redux'
import Immutable from 'immutable'
import hoistStatics from 'hoist-non-react-statics'
import Spinner from 'components/Spinner'
import { getMyCourses } from 'store/actions/courses'
import { CourseType } from 'common-proptypes'
import { withIdle } from 'libreact/lib/IdleSensor'
import CatastrophicErrorDisplay from 'components/CatastrophicErrorDisplay'

const idleProps = {
  ms: 5 * 60 * 1000,
  events: ['mousemove', 'mousedown', 'resize', 'keydown', 'touchstart', 'wheel', 'visibilitychange'],
}

const mapStateToProps = state => {
  return {
    pending: state.courses.get('pending'),
    dateLoaded: state.courses.get('dateLoaded'),
    errors: state.courses.get('errors').toJS(),
    courses: state.courses.get('allCourses', new Immutable.Map()).toList().toJS(),
  }
}
const CoursesLoader = withIdle(connect(mapStateToProps)(class CoursesLoaderInner extends React.PureComponent {
  static propTypes = {
    blocking: PropTypes.bool,
    // hoc-mapped
    idle: PropTypes.bool,
    // state-mapped
    dispatch: PropTypes.func.isRequired,
    courses: PropTypes.arrayOf(CourseType),
    pending: PropTypes.bool,
    dateLoaded: PropTypes.instanceOf(Date),
    errors: PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        message: PropTypes.string,
        date: PropTypes.instanceOf(Date),
      }),
    ])),
  }

  componentDidMount() {
    this.fetchProducts()
  }

  componentDidUpdate(prevProps) {
    this.fetchProducts(prevProps)
  }

  fetchProducts = (prevProps) => {
    const {
      pending,
      dateLoaded,
      idle,
    } = this.props
    return new Promise(resolve => {
      if(pending) {
        return resolve()
      }
      if(!dateLoaded) {
        return resolve(this.dispatchFetch())
      }
      if(!idle && prevProps.idle) {
        return resolve(this.dispatchFetch())
      }
      return resolve()
    })
  }

  dispatchFetch = () => {
    const {
      dispatch,
    } = this.props
    return dispatch(getMyCourses())
  }

  render() {
    const {
      blocking,
      children,
      pending,
      dateLoaded,
      errors,
    } = this.props

    if(blocking) {
      if(pending && !dateLoaded) {
        return (
          <div style={{ minHeight: 'calc(100vh - 12rem)' }}>
            <Spinner />
          </div>
        )
      }
      if(!(errors && errors.length) && !pending && !dateLoaded) {
        return <span>...</span>
      }
      if(errors && errors.length) {
        return (
          <CatastrophicErrorDisplay
            title={(
              <>
                <div style={{ fontSize: '1.75em', lineHeight: 1 }}><span role="img" aria-label="ouchie">🐞</span></div>
                <div>Something went wrong</div>
              </>
            )}
            description="An error ocurred while trying to load course info."
            errors={errors}
          />
        )
      }
    }

    return (
      <React.Fragment>
        {children}
      </React.Fragment>
    )
  }
}), '', idleProps)

export default CoursesLoader


export function withCourses(Component) {
  const C = props => {
    const { wrappedComponentRef, ...remainingProps } = props //eslint-disable-line react/prop-types

    return (
      <CoursesLoader>
        <Component
          {...remainingProps}
          ref={wrappedComponentRef}
        />
      </CoursesLoader>
    )
  }

  C.displayName = `withCourses(${Component.displayName || Component.name})`
  C.WrappedComponent = Component

  return hoistStatics(C, Component)
}
